export default __webpack_public_path__ + "static/media/datavue.e08983cc.svg";